import { PaletteOptions } from "@mui/material";
import {
  backgroundLight,
  errorLight,
  infoLight,
  primaryLight,
  secondaryLight,
  successLight,
  textLight,
  warningLight,
} from "./Colors";

export const LIGHT_PALETTE_OPTIONS: PaletteOptions = {
  primary: primaryLight,
  warning: warningLight,
  secondary: secondaryLight,
  error: errorLight,
  success: successLight,
  info: infoLight,
  background: backgroundLight,
  text: textLight,
};
